import {
  cache_clear,
  cache_read,
  cache_write,
  stat_cacheName,
  vehicle_cacheName,
} from "src/components/js/CacheFunctions";
import { checkResponse, parseJSONDate } from "../js/statics1";
import vehicleClass from "./vehicleClass";
import { gridKeikka_copyJSON } from "src/pages/Grid/GridKeikka/gridKeikkaFunctions";

export async function vehicle_fetchList(ownerAsiakasId, token, dayVehicles = []) {
  if (ownerAsiakasId === 0) return [];
  if (dayVehicles.length === 0) dayVehicles = [-1];
  // remove duplicates from dayVehicle array and sort
  dayVehicles = [...new Set(dayVehicles)].sort((a, b) => a - b);

  const fullUrl =
    import.meta.env.VITE_SERVER_URL +
    "/api/vehicle/list/" +
    ownerAsiakasId +
    "/" +
    dayVehicles.join(",");
  const c = cache_read(vehicle_cacheName, fullUrl);
  if (c) return c;

  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(fullUrl, requestOptions);
  const cResponse = await checkResponse(response, "vehicleFunctions.js:vehicle_fetchList");
  if (!cResponse.success) {
    return [];
  }
  const result = cResponse.data;
  const now = new Date();
  for (let i = 0; i < result.length; i++) {
    const start = result[i].firstDate == null ? null : parseJSONDate(result[i].firstDate);
    const end = result[i].lastDate == null ? null : parseJSONDate(result[i].lastDate);
    result[i].firstDate = start;
    result[i].lastDate = end;
    result[i].active = (start <= now || start == null) && (end >= now || end == null);
  }

  cache_write(vehicle_cacheName, fullUrl, result, 360);
  return result;
}

export async function vehicleTypes_fetchList(token) {
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/vehicle/listTypes";
  const c = cache_read(vehicle_cacheName, fullUrl);
  if (c) return c;

  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(fullUrl, requestOptions);
  const cResponse = await checkResponse(response, "vehicleFunctions.js:vehicleTypes_fetchList");
  if (!cResponse.success) {
    console.log(cResponse.message);
    return [];
  }
  const result = cResponse.data;
  cache_write(vehicle_cacheName, fullUrl, result, 360);
  return result;
}

export async function vehicle_setDefaultPumppari(vehicleId, personId, token) {
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      vehicleId: vehicleId,
      personId: personId,
    }),
  };
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/vehicle/setDefaultPumppari";
  const response = await fetch(fullUrl, requestOptions);
  const cResponse = await checkResponse(response, "vehicleFunctions.js:vehicle_setDefaultPumppari");
  cache_clear(vehicle_cacheName);
  return cResponse.success;
}

export async function vehicle_save_to_db(vehicle, token, socket) {
  vehicle = gridKeikka_copyJSON(vehicle); // remove circular references
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(vehicle),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/vehicle/save",
    requestOptions
  );
  const cResponse = await checkResponse(response, "vehicleFunctions.js:vehicle_save_to_db");
  if (!cResponse.success) {
    console.log(cResponse.message);
    return [];
  }
  const result = cResponse.data;
  cache_clear(vehicle_cacheName, 0, socket);
  return result;
}
export function vehicle_newVehicle(ownerAsiakasId, token) {
  cache_clear(vehicle_cacheName);
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/vehicle/new/" + ownerAsiakasId;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  return fetch(fullUrl, requestOptions);
}

export async function vehicle_fetch(vehicleId, token) {
  if (vehicleId == 0) return this;
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/vehicle/get/" + vehicleId;
  const c = cache_read(vehicle_cacheName, fullUrl);
  if (c) return c;
  const response = await fetch(fullUrl, {
    method: "GET",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "vehicleClass.js:fetchVehicle");
  const fetchJson = cResponse.data;
  const vehicle = vehicle_get_parseJson(fetchJson);
  cache_write(vehicle_cacheName, fullUrl, vehicle, 360);
  return vehicle;
}
export function vehicle_get_parseJson(json) {
  if (json[0]?.asiakasId > 0) json = json[0];
  const vehicle = new vehicleClass();
  vehicle.vehicleId = json.vehicleId;
  vehicle.asiakasId = json.asiakasId;
  vehicle.firstDate = json.firstDate;
  vehicle.lastDate = json.lastDate;
  vehicle.foreignKey = json.foreignKey;
  vehicle.vehicleNimi = json.vehicleNimi;
  vehicle.vehicleNo = json.vehicleNo;
  vehicle.vehiclePuomi = json.vehiclePuomi;
  vehicle.vehicleRegNo = json.vehicleRegNo;
  vehicle.vehicleTypeId = json.vehicleTypeId;
  vehicle.vehicleTypeName = json.vehicleTypeName;
  vehicle.vehicleTypeShortName = json.vehicleTypeShortName;
  vehicle.defaultKuski_personId = json.defaultKuski_personId;
  vehicle.isLoaded = true;
  vehicle.hasError = false; // vehicle.vehicleAsiakasId = fetchJson[0].asiakasId;
  vehicle.isLoaded = true;
  return vehicle;
}

export async function vehiclePerson_getList(ownerAsiakasId, token) {
  const fullUrl =
    import.meta.env.VITE_SERVER_URL + "/api/vehicle/stat/personList/" + ownerAsiakasId;
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  const c = cache_read(stat_cacheName, fullUrl);
  if (c) return c;
  const response = await fetch(fullUrl, requestOptions);
  const cResponse = await checkResponse(response, "vehicleFunctions.js:vehiclePerson_getList");
  if (!cResponse.success) {
    console.log(cResponse.message);
    return [];
  }
  const result = cResponse.data;
  cache_write(stat_cacheName, fullUrl, result, 2880);
  return result;
}
